<template>
  <div class="trunBack">
    <i class="el-icon-arrow-left" @click="returnBack"></i>
    <div class="trunBackContent">{{ content }}</div>
  </div>
</template>
<script>
export default {
  props: {
    content: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    }
  },
  methods: {
    returnBack() {
      this.$router.push({ path: this.url })
    }
  }
};
</script>
<style lang="less">
.trunBack {
  padding: 0.5rem 0rem;

  .el-icon-arrow-left {
    font-size: 2rem;
    margin-top: 0.2rem;
    float: left;
  }

  .trunBackContent {
    font-size: 1.5rem;
    text-align: center;
  }
}</style>